export const API_STORE_PRODUCT =
  "https://cafe-notes-api.herokuapp.com/api/product";
